import {useState} from "react";
import SalesforceFieldError from "./SalesforceFieldError";
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function QuestionTextarea({ questionInfo, updateQuestionValue , sousCritereIndex, questionIndex , getNumberFiliereActif , getNumberCritereActif , data}) {

    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */ 

    const [value, setValue] = useState(questionInfo.value);

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const questionLookup = buildQuestionLookup(currentPeriod);
    let visible = isQuestionVisible(questionInfo, {
      dataFiltres: currentPeriod?.filtres,
      questionLookup
    });
    const questions = data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[sousCritereIndex].questions;


    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */ 

    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        updateQuestionValue(sousCritereIndex, questionIndex, newValue);
    };

    try {
        questions[questionIndex].visible = visible;
      } catch {
  
      }

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */ 

    if (!visible) return null;

    return (
        <div className="question" id={"id:" + questionInfo.id}>
                {/*Affiche l'étiquette de la question*/}
                <label className="questionTitle">
                    {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
                </label>
                <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
                <div className="groupTextarea">
                {/*Affiche l'input de la question*/}
                <textarea id={questionInfo.idForm} name={questionInfo.idForm} value={value} onChange={handleChange} size="20" required={questionInfo.required} placeholder={questionInfo.placeholder} pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" className="text"/>
                <SalesforceFieldError error={questionInfo.salesforceError} />
                </div>
                
        </div>
    );
}
